module.exports = __webpack_public_path__ + "img/porte_fenetre.edd381b.svg";